// Este arquivo configura polyfills necessários para bibliotecas que dependem do Node.js
// Configuração simplificada sem importações diretas

// Configurar polyfill para o objeto global 'process'
if (typeof window !== 'undefined') {
  // Configurar process se não existir
  if (typeof window.process === 'undefined') {
    window.process = {};
  }
  
  window.process.env = window.process.env || {};
  window.process.browser = true;
  
  // Configurar variáveis de ambiente necessárias
  const env = window.process.env;
  
  // Garantir que NODE_ENV está definido
  if (!env.NODE_ENV) {
    env.NODE_ENV = 'production';
  }
  
  // Definir variáveis específicas da aplicação se não existirem
  if (!env.REACT_APP_API_URL) {
    env.REACT_APP_API_URL = 'https://senhas.cartoriocriciumasc.com.br/api';
  }
} 